import { createEntityAdapter } from '@reduxjs/toolkit';
import { QuestionResponsePrivate } from '@tests/types';

export const questionsAdapter = createEntityAdapter<QuestionResponsePrivate<string>>();
